module.exports = __webpack_public_path__ + "front/img/88.ecbf9d8b.png";